import config from '../../config';
import { encryptData } from '../../utils/cryptoUtils';

const postReconciliation = async (route, payload, signal) => {
  let response;
  try {
    response = await fetch(`${config.API_BASE_URL}${route}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: encryptData(payload),
      signal,
    });
  } catch (error) {
    if (error.name === 'AbortError') throw error;
    throw new Error('Unable to connect to the collection reconciliation service.');
  }

  let result;
  try {
    result = await response.json();
  } catch (error) {
    throw new Error('The reconciliation service returned an invalid response.');
  }

  if (!response.ok || Number(result?.status) !== 200 || Number(result?.success) !== 1) {
    throw new Error(result?.message || 'Unable to load collection reconciliation data.');
  }
  return result.data || {};
};

export function getCollectionReconciliation(payload, signal) {
  return postReconciliation('getCollectionReconciliation', payload, signal);
}

export function saveCollectionReconciliationDecision(payload) {
  return postReconciliation('manualReconcileCollectionTransaction', payload);
}

export function exportTransactionsCsv(transactions) {
  const fields = [
    ['transaction_id', 'transaction_id'], ['source_code', 'source_code'], ['source_transaction_id', 'source_transaction_id'],
    ['loan_account_no', 'loan_account_no'], ['borrower_name', 'borrower_name'], ['collection_date', 'collection_date'],
    ['payment_mode', 'payment_mode'], ['received_amount', 'received_amount'], ['expected_amount', 'expected_amount'],
    ['matched_amount', 'matched_amount'], ['unreconciled_amount', 'unreconciled_amount'], ['difference_amount', 'difference_amount'],
    ['short_amount', 'short_amount'], ['excess_amount', 'excess_amount'], ['reconciliation_status', 'reconciliation_status'],
    ['exception_code', 'exception_code'], ['batch_id', 'batch_id'], ['created_at', 'created_at'], ['updated_at', 'updated_at'],
  ];
  const csv = [fields.map(([, header]) => header).join(','), ...transactions.map((transaction) => fields.map(([field]) => `"${String(transaction[field] ?? '').replaceAll('"', '""')}"`).join(','))].join('\r\n');
  const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8;' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = 'collection-reconciliation.csv';
  link.click();
  URL.revokeObjectURL(url);
}
